var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft } from "@fortawesome/pro-light-svg-icons";
import Button from "syf-component-library/ui/atoms/Button";
import Inline from "syf-component-library/ui/spacing/Inline";
import i18n from "../../../strings/i18n";
import { BackFooter, BackNotification } from "./CardBack.styles";
var CardBack = function (_a) {
    var setIsFlipped = _a.setIsFlipped, notificationList = _a.notificationList;
    var backClickHandler = function () {
        setIsFlipped(false);
    };
    return (_jsxs(_Fragment, { children: [_jsx(BackNotification, { "data-test": "back-notfications", notificationList: notificationList }), _jsx(BackFooter, { children: _jsxs(Button, __assign({ "data-test": "card-back-button", buttonType: "ghost", onClick: backClickHandler, "data-type": "Flip card", "data-reason": "Back", "data-object": "button", "data-analytics": "clicktrackingevent" }, { children: [_jsx(FontAwesomeIcon, { icon: faAngleLeft, size: "lg" }), _jsx(Inline, { size: "xsmall" }), i18n({ button: "back" })] })) })] }));
};
export default CardBack;
//# sourceMappingURL=CardBack.js.map